var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay-out-sidebar",class:{'-visible': _vm.sidebarVisible},on:{"click":_vm.hideSidebar}})}
var staticRenderFns = []

export { render, staticRenderFns }